module.exports = __webpack_public_path__ + "img/fig26.46e97798.jpg";